import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { useAlerts } from "../../context";
import { BaseLayout } from "../../components/Layouts/BaseLayout";
import { PageHeaderConnector } from "../../components/Hotels/PageHeader/PageHeaderConnector";
import { PageBannerConnector } from "../../components/Hotels/PageBanner/PageBannerConnector";
import { PageTabsConnector } from "../../components/Hotels/PageTabs/PageTabsConnector";
import { Section } from "../../components/Section";

const HotelDetails = ({ data, pageContext, location }) => {
	const { alertsCount } = useAlerts();

	const { data: hotelData, merchandising } = data.hotel;

	return (
		<BaseLayout
			location={location}
			pageContext={pageContext}
			altLangPages={data.altLangPages}
			alerts={alertsCount}>
			<Section>
				<PageHeaderConnector hotelData={hotelData} />
				<PageBannerConnector hotelData={hotelData} merchandising={merchandising} />
			</Section>
			<Section paddingControl="removeTop">
				<PageTabsConnector hotelData={hotelData} hotelName={hotelData.HotelName} />
			</Section>
		</BaseLayout>
	);
};

HotelDetails.propTypes = {
	data: PropTypes.object.isRequired,
	pageContext: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};
export default HotelDetails;

export const pageQuery = graphql`
	query GetHotelDetailsPageData($id: String!, $ctf_id: String!) {
		hotel(id: { eq: $id }) {
			...hotelDetails
		}
		altLangPages: allSitePage(filter: { context: { ctf_id: { eq: $ctf_id } } }) {
			edges {
				...LanguageToggle
			}
		}
	}
`;
